<template>
    <div>
        <slot/>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'BaseWidget',

        methods: {
            ...mapActions([
                'getLocations'
            ])
        },

        created() {
            this.getLocations();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/controls/BaseWidget.vue